export interface IMediaItem {
  alt?: string | null;
  fullUrl: string;
  id?: number | null;
  mediaType: EMediaType;
  thumbnailUrl: string;
  videoUrl?: string;
}

export enum EMediaType {
  Image = 'image',
  Video = 'video',
}

export interface IVideo {
  videoId: string;
  thumbnailUrl: string;
  fullUrl: string;
}

export enum IGallerySections {
  Architecture = 'architecture',
  Parking = 'parking',
  Videos = 'Video',
}

export interface IGalleryMediaItem {
  type: IGallerySections;
  id: string;
  title: string;
  media: IMediaItem[];
}

export interface IGalleryVideoItem {
  type: IGallerySections;
  id: string;
  title: string;
  media: IVideo[];
}

export interface IFullscreenSlide {
  node: React.ReactNode;
  thumbnailNode: React.ReactNode;
}

export type IGallery = Array<IGalleryMediaItem | IGalleryVideoItem>;
